import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postAPI } from "../service/http-service";
import { AuthApi } from "../auth/authEndpointConfig/AuthEndpointConfig";

export interface forgetPassword {
  centerCode: string;
  email: string;
  mobileNo: any;
}

let initialState: any = {
  entity: {
    forgetPassReqParam: {},
    forgetPassResponseValues: {},
  },
};

let forgetPassFormValues: forgetPassword = {
  centerCode: "",
  email: "",
  mobileNo: "",
};

//Get OTP API call
export const getOTP = createAsyncThunk(
  "auth/getOTP",
  async (requestParam: forgetPassword) => {
    forgetPassFormValues = requestParam;
    try {
      const response = await postAPI(
        AuthApi.forgetPassword,
        forgetPassFormValues
      );
      return response;
    } catch (err) {
      return err;
    }
  }
);

const forgetPasswordSlice = createSlice({
  name: "forgetPassword",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOTP.fulfilled, (state, action) => {
      state.entity.forgetPassResponseValues = action.payload;
      state.entity.forgetPassReqParam = forgetPassFormValues;
    });
    builder.addCase(getOTP.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const forgetPasswordReducer = forgetPasswordSlice.reducer;
export default forgetPasswordReducer;
